import smartToast from '../../util/smart_toast';
import secureAxios from '../secure_axios';

const baseUrl = 'pendencia-formulario-acompanhamento'

async function servGetPendenciasFormularioAcompanhamento(query, page) {

    const queryRequest = {
        ...query,
        page: page
    };

    const response = await secureAxios.get(`${baseUrl}`,
        { params: queryRequest }
    )
    return response
}

async function servGetPendenciasFormularioAcompanhamentoMonitoramento(query) {

    try {
        const response = await secureAxios.get(baseUrl + '/monitoramento',
            { params: query }
        )
        return response
    } catch (error) {
        console.error('Erro no service', error);
        throw error
    }

}

async function servAtualizaPendenciaFormulario(updatePendencia) {
    const response = await secureAxios.patch(`${baseUrl}`, updatePendencia)
    return response
}

async function servGetPendenciaFormularioComHistorico(pendenciaId) {
    const response = await secureAxios.get(`${baseUrl}/historico`, {
        params: { 'pendenciaId': pendenciaId }
    })
    return response
}

async function servGetPendenciasPrevisaoVencida(page) {
    try {
        const response = await smartToast(
            secureAxios.get(`${baseUrl}/data-previsao-resolucao-vencida`, {
                params: { 'page': page }
            })
            , { loadingMessage: 'Buscando pendências...', apenasLoading: true }
        );
        return response
    } catch (error) {
        console.error('Erro no service', error);
        console.error(error);
    }
}

export {
    servGetPendenciasFormularioAcompanhamento,
    servGetPendenciasFormularioAcompanhamentoMonitoramento,
    servAtualizaPendenciaFormulario,
    servGetPendenciaFormularioComHistorico,
    servGetPendenciasPrevisaoVencida
}